// Third Party
import React from 'react';
import moment from 'moment';

// Components
import { SecondaryButton } from '../../buttons';
import { UnitInput, EditableInput } from '../../inputs';

// Utils
import { formatMessage, FormattedMessage } from '../../../../utils/i18n';
import { YieldParamsType } from '../../../../utils/constants';
import User from '@/types/user';
import CustomYieldParams from '@/types/custom-yield-params';
import ShelvableInstrument from '@/types/shelvable-instrument';
import CompliantInstrument from '@/types/compliant-instrument';
import Shelf from '@/types/shelf';
import Nullable from '@/types/nullable';

type Props = {
  user: User;
  title?: string;
  onSubmit: (config: CustomYieldParams, shelfInfo: ShelvableInstrument & CompliantInstrument) => void;
  enableTerm?: boolean;
  benchmarkLipperId?: number;
  filteredShelves?: Shelf[];
  complianceComparisons?: string[];
};

type State = {
  name: string;
  rate: Nullable<number>;
};

class QuickAddHISASimulator extends React.Component<Props, State> {
  private initialState: State = {
    name: formatMessage('EditPortfolioModal.HISASimulator.DefaultName'),
    rate: 1,
  };

  readonly state: State = this.initialState;

  clearForm = () => {
    this.setState(this.initialState);
  };

  onAdd = () => {
    const { name, rate } = this.state;

    if (rate === null || name.trim() === '') {
      return;
    }

    this.props.onSubmit(
      {
        name,
        rate,
        automaticRenewal: true,
        startDate: moment().utc().startOf('year').startOf('day').subtract('10', 'years').startOf('day').toDate(),
        term: 1,
        frequency: 'daily',
        termUnits: 'years',
        benchmarkLipperId: this.props.benchmarkLipperId,
        type: YieldParamsType.HISA,
      },
      {
        filteredShelves: this.props.filteredShelves,
        complianceComparisons: this.props.complianceComparisons,
      },
    );

    this.clearForm();
  };

  onRateChange = (value: string) => {
    let rate: Nullable<number> = null;

    if (value.trim() !== '') {
      rate = Number(value);
    }

    this.setState({ rate });
  };

  onNameChange = (name: string) => {
    this.setState({ name });
  };

  renderSimulator = () => {
    const { name, rate } = this.state;

    return (
      <>
        <div className="simulator-row justify-content-between">
          <EditableInput
            compact
            data-private
            data-dd-privacy="mask"
            value={name}
            placeholder={formatMessage('EditPortfolioModal.HISASimulator.PlaceholderName')}
            onValueChange={(value: string) => this.onNameChange(value)}
            className="custom-name"
          />
        </div>

        <div className="simulator-row">
          <div className="rate-container">
            <span className="field-label">
              <FormattedMessage id="EditPortfolioModal.HISASimulator.Rate" />
            </span>

            <UnitInput compact name="simulator-rate" type="number" min={0} value={rate === null ? '' : rate} unitSymbol="%" onValueChange={this.onRateChange} />
          </div>
        </div>

        <div className="simulator-row justify-content-end">
          <SecondaryButton compact className="add-btn" onClick={this.onAdd}>
            <span>{formatMessage('EditPortfolioModal.GICSimulator.AddToPortfolio')}</span>
          </SecondaryButton>
        </div>
      </>
    );
  };

  render() {
    const { title } = this.props;

    return (
      <div className="simulator-section">
        {title && <span className="simulator-section-title">{title}</span>}

        <div className="d-flex simulator-wrapper">{this.renderSimulator()}</div>
      </div>
    );
  }
}

export default QuickAddHISASimulator;
